// extracted by mini-css-extract-plugin
module.exports = {"container":"EventInfoCard_container__3S6vq","cardHeader":"EventInfoCard_cardHeader__QZ9Ef","hr":"EventInfoCard_hr__2csll","button":"EventInfoCard_button__3--RS"};